import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>111</Summary>
        <Details>
          <Text>1.1. Lorem</Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
